import { FailedMessagesProfileItemModel } from '../../models/profile/failed-messages-profile-item.model';

export class FailedMessagesProfileItemBriefLoad {
  public static readonly type = '[FailedMessagesProfileItemBrief] Load';

  constructor(public payload: number) {}
}

export class FailedMessagesProfileItemBriefPartnerListLoad {
  public static readonly type = '[FailedMessagesProfileItemBrief] Partner List Load';

  constructor(public payload: string) {}
}

export class FailedMessagesProfileItemBriefUpdate {
  public static readonly type = '[FailedMessagesProfileItemBrief] Update';

  constructor(public payload: FailedMessagesProfileItemModel) {}
}

export class FailedMessagesProfileItemBriefDelete {
  public static readonly type = '[FailedMessagesProfileItemBrief] Delete';

  constructor(public payload: number) {}
}

export class FailedMessagesProfileItemBriefInitialState {
  public static readonly type = '[FailedMessagesProfileItemBrief] Set Initial State';
}
